import { useCallback } from "react";
import { usePRD2040_R01Store } from "./Store_PRD2040_R01";
import { getBomCompareList, getMountPartList, downloadBomExcel_PRD2040_R01, downloadMountExcel_PRD2040_R01 } from "./Api_PRD2040_R01";
import { downloadExcel } from "src/utils/blob/blobUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useToast } from "src/hooks/useToast";
import useUiuxStore from "src/store/useUiuxStore";
import { showWarning, ShowSuccessFetch } from "src/utils/toast/toastUtil";

export const Content_PRD2040_R01 = () => {
    const { setMessage } = useUiuxStore();

    const {
        PRD2040_R01Filter,
        activeTab,
        setTabData,
        initData,
        setTabScrollTop,
    } = usePRD2040_R01Store();

    useFetchActionbarAuth("PRD2040_R01");

    // 조회
    const fetchData = useCallback(async () => {
        const { productWorkNo, compareItemCd } = PRD2040_R01Filter;

        if (!productWorkNo) {
            showWarning('공정작업을 선택해주세요.');
            return;
        }

        if (!compareItemCd) {
            showWarning('비교품목을 선택해주세요.');
            return;
        }

        try {
            setTabScrollTop(activeTab, null);

            // 활성화된 탭에 따라 API 호출
            if (activeTab === 'BOM') {
                // BOM 검토 조회
                const bomRes = await getBomCompareList(productWorkNo, compareItemCd);
                if (bomRes?.data?.data) {
                    setTabData('BOM', bomRes.data.data);
                }
                ShowSuccessFetch(setMessage, `BOM 검토 조회가 완료되었습니다.`);
            } else if (activeTab === 'MOUNT') {
                // 실장좌표 검토 조회
                const mountRes = await getMountPartList(productWorkNo, compareItemCd);
                if (mountRes?.data?.data) {
                    setTabData('MOUNT', mountRes.data.data);
                }
                ShowSuccessFetch(setMessage, `실장좌표 검토 조회가 완료되었습니다.`);
            }

            setTimeout(() => setMessage(""), 5000);
        } catch (error) {
            console.error('조회 실패:', error);
            showWarning('조회 중 오류가 발생했습니다.');
        }
    }, [PRD2040_R01Filter, activeTab, setTabData, setMessage, setTabScrollTop]);

    // 초기화
    const initContainerData = useCallback(() => {
        initData();
        setMessage("");
    }, [initData, setMessage]);

    // 엑셀
    const handleExcelClick = useCallback(async () => {
        const { productWorkNo, compareItemCd } = PRD2040_R01Filter;

        if (!productWorkNo) {
            showWarning('공정작업을 선택해주세요.');
            return;
        }
        if (!compareItemCd) {
            showWarning('비교품목을 선택해주세요.');
            return;
        }

        try {
            const response = activeTab === 'BOM'
                ? await downloadBomExcel_PRD2040_R01(productWorkNo, compareItemCd)
                : await downloadMountExcel_PRD2040_R01(productWorkNo, compareItemCd);

            const data = response.data.data;
            let blob: Blob;

            if (Array.isArray(data)) {
                const byteArray = new Uint8Array(data);
                blob = new Blob([byteArray], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
            } else if (typeof data === 'string') {
                const binaryString = atob(data);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }
                blob = new Blob([byteArray], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
            } else {
                throw new Error('지원하지 않는 데이터 형식입니다.');
            }

            const fileName = activeTab === 'BOM'
                ? 'BOM검토-excel.xlsx'
                : '실장좌표검토-excel.xlsx';

            downloadExcel(blob, fileName);
        } catch (error) {
            console.error('엑셀 다운로드 중 오류 발생:', error);
            showWarning('엑셀 다운로드 중 오류가 발생했습니다.');
        }
    }, [PRD2040_R01Filter, activeTab]);

    return {
        fetchData,
        initContainerData,
        handleExcelClick,
    };
};
